import React, {useEffect, useState} from 'react'
import {Form, Input, DatePicker, Select} from "antd";
import { getEmployeesAsSelect } from '../../services/serviceEmployee';

const AppointmentFilter = () => {
    const [employee, setEmployee] = useState([])

    useEffect(() => {
        getEmployeesAsSelect()
            .then(({data}) => {
                if(data && data.length) {
                    const structured = data.map(({label, value}) => ({label, value}));
                    setEmployee(structured);
                }
            })
    }, [])

    return(
        <React.Fragment>
            <Form.Item
                name={'customerName'}
                label={'Müşteri Adı'}
                initialValue={''}
            >
                <Input />
            </Form.Item>
            <Form.Item
                name={'createdBy'}
                label={'Oluşturan'}
                initialValue={''}
            >
                <Select showSearch options={employee} />
            </Form.Item>
            <Form.Item
                name={'planningDate'}
                label={'Randevu Tarihi'}
                initialValue={''}
            >
                <DatePicker />
            </Form.Item>
        </React.Fragment>
    )
}
export default AppointmentFilter